<template lang="pug">
  div.add-top-margin.message(:class="{'is-warning':onlyWarnings, 'is-danger':hasErrors, 'is-success':noWarnings}" )
    .message-body
      h3.has-text-weight-bold {{ displayTitle }}
      .content
        ul.content
          li(v-if="errors.SEVERITIES['fatal error']") {{ $t('Fatal Errors') }}: {{errors.SEVERITIES['fatal error']}}
          li(v-if="errors.SEVERITIES['error']") {{ $t('Errors') }}: {{errors.SEVERITIES['error']}}
          li(v-if="errors.SEVERITIES['warning']") {{ $t('Warning') }}: {{errors.SEVERITIES['warning']}}
          li(v-if="errors.SEVERITIES['info']") {{ $t('Information') }}: {{errors.SEVERITIES['info']}}
        p(v-if="onlyWarnings")
          | {{ $t('You can download the EcoSpold2 files.') }}
          | {{ $t('They can be opened in ecoEditor, but it will not be possible to submit it before the errors listed in validation log are corrected.')}}
          | {{ $t('You can choose one of two options:')}}
          ol
            li {{ $t('make the corrections in ecoEditor;') }}
            li {{ $t('make the corrections in the XLSX template and convert again.') }}
        p(v-else-if="fatalErrors")
          | {{ $t('The conversion could not be finished due to the errors displayed above.') }}
          | {{ $t('Please download the XLSX template files for a detailed validation log.')}}
        p(v-else-if="hasErrors")
          | {{ $t('Please download the XLS template files for a detailed validation log.')}}
          | {{ $t('In some cases an EcoSpold2 file can be created, but we strongly recomment to revise the template.') }}
</template>

<script>
export default {
  name: 'ErrorStatistics',
  data() {
    return {
      displayTitle: ''
    }
  },
  mounted() {
    this.displayTitle = this.title || this.errorMessage
  },
  props: {
    errors: {
      type: Object,
      required: true
    },
    title: {
      type: String
    }
  },
  computed: {
    errorMessage() {
      if (this.noWarnings) {
        return this.$t('Additional information was found during data conversion')
      } else if (this.onlyWarnings) {
        return this.$t('Warnings but no error was found during data conversion')
      } else if (this.fatalErrors) {
        return this.$t('Fatal errors were found during data conversion')
      } else {
        return this.$t('Errors were found during data conversion')
      }
    },
    fatalErrors() {
      return !!this.errors.SEVERITIES['fatal error']
    },
    hasErrors() {
      return !!this.errors.SEVERITIES['fatal error'] || !!this.errors.SEVERITIES['error']
    },
    onlyErrors() {
      return !this.errors.SEVERITIES['fatal error'] && this.errors.SEVERITIES['error']
    },
    onlyWarnings() {
      return !this.errors.SEVERITIES['fatal error'] && !this.errors.SEVERITIES['error'] && this.errors.SEVERITIES['warning']
    },
    noWarnings() {
      return !this.errors.SEVERITIES['fatal error'] && !this.errors.SEVERITIES['error'] && !this.errors.SEVERITIES['warning']
    }
  }
}
</script>

<style scoped>
  .add-top-margin {
    margin-top: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/ErrorStatistics.vue